import React, { ReactElement } from "react";

import { HEADER_HEIGHT } from "./constants";

const TeckLogo = (): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{
      width: `${HEADER_HEIGHT * 1.586}px`,
      height: `${HEADER_HEIGHT / 1.567}px`,
    }}
  >
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="refresh">
      <g fill="#505B64">
        <path d="M25.444 4.291s-1.325 1.293-2.243 2.201C18.514 3.068 11.909 3.456 7.676 7.689c-2.47 2.47-3.623 5.747-3.484 8.983h4c-.141-2.212.618-4.467 2.308-6.158 2.663-2.663 6.735-3.043 9.812-1.162-1.042 1.032-2.245 2.238-2.245 2.238-.841 1.009.104 1.592.584 1.577l5.624-.001.539.001H26.449c.298 0 .54-.243.54-.541V4.895c.034-.707-.742-1.393-1.545-.604zM6.555 27.709s1.326-1.293 2.243-2.201c4.688 3.424 11.292 3.036 15.526-1.197 2.47-2.471 3.622-5.747 3.484-8.983h-4.001a7.949 7.949 0 01-2.308 6.159c-2.663 2.662-6.735 3.043-9.812 1.161 1.042-1.032 2.245-2.238 2.245-2.238.841-1.01-.104-1.592-.584-1.577l-5.624.002c-.297 0-.54-.002-.54-.002H5.551a.542.542 0 00-.541.541v7.732c-.033.706.743 1.392 1.545.603z"></path>
      </g>
    </symbol>
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="refresh">
      <g fill="#505B64">
        <path d="M25.444 4.291s-1.325 1.293-2.243 2.201C18.514 3.068 11.909 3.456 7.676 7.689c-2.47 2.47-3.623 5.747-3.484 8.983h4c-.141-2.212.618-4.467 2.308-6.158 2.663-2.663 6.735-3.043 9.812-1.162-1.042 1.032-2.245 2.238-2.245 2.238-.841 1.009.104 1.592.584 1.577l5.624-.001.539.001H26.449c.298 0 .54-.243.54-.541V4.895c.034-.707-.742-1.393-1.545-.604zM6.555 27.709s1.326-1.293 2.243-2.201c4.688 3.424 11.292 3.036 15.526-1.197 2.47-2.471 3.622-5.747 3.484-8.983h-4.001a7.949 7.949 0 01-2.308 6.159c-2.663 2.662-6.735 3.043-9.812 1.161 1.042-1.032 2.245-2.238 2.245-2.238.841-1.01-.104-1.592-.584-1.577l-5.624.002c-.297 0-.54-.002-.54-.002H5.551a.542.542 0 00-.541.541v7.732c-.033.706.743 1.392 1.545.603z"></path>
      </g>
    </symbol>
    <symbol
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 85 35"
      id="teck-logo"
    >
      <defs>
        <path
          d="M15.145 7.845v25.772H8.528V7.845H0V2.179h24.576l-1.995 5.666h-7.436zm23.28 24.649c-1.78.851-4.221 1.779-8.48 1.779-7.458 0-11.419-5.373-11.419-12.117 0-7.113 4.472-12.395 10.995-12.395 6.712 0 10.302 4.808 10.302 12.35 0 .99-.096 1.65-.096 1.98H24.629c-.093 1.695 1.306 5.233 5.874 5.233 4.128 0 6.723-1.534 7.704-2.148l.218 5.318zM29.66 14.477c-2.84 0-4.613 2.164-5.079 5.044h9.416c0-1.277-.47-5.044-4.337-5.044zM84.443 33.61l-10.251-13.01 10.155-10.18h-7.27l-8.339 8.483V.76h-6.29v32.851h6.29V22.723l8.247 10.888h7.458zm-24.732-6c-.427.249-2.686 1.43-5.44 1.43-4.197 0-6.248-3.114-6.248-7.166 0-3.299 2.237-6.975 6.431-6.975 2.61 0 4.52 1.134 4.846 1.368l.363-5.212c-1.34-.67-3.272-1.295-5.77-1.295-6.894 0-12.159 5.232-12.159 12.444 0 6.883 4.567 12.068 11.742 12.068 2.773 0 4.96-.73 6.456-1.457l-.221-5.205z"
          id="ca"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="cb" fill="#fff">
          <use xlinkHref="#ca"></use>
        </mask>
        <use fill="#131413" xlinkHref="#ca"></use>
        <g mask="url(#cb)" fill="#FFF">
          <path d="M0 0h85v35H0z"></path>
        </g>
      </g>
    </symbol>
    <symbol
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 85 35"
      id="teck-logo"
    >
      <defs>
        <path
          d="M15.145 7.845v25.772H8.528V7.845H0V2.179h24.576l-1.995 5.666h-7.436zm23.28 24.649c-1.78.851-4.221 1.779-8.48 1.779-7.458 0-11.419-5.373-11.419-12.117 0-7.113 4.472-12.395 10.995-12.395 6.712 0 10.302 4.808 10.302 12.35 0 .99-.096 1.65-.096 1.98H24.629c-.093 1.695 1.306 5.233 5.874 5.233 4.128 0 6.723-1.534 7.704-2.148l.218 5.318zM29.66 14.477c-2.84 0-4.613 2.164-5.079 5.044h9.416c0-1.277-.47-5.044-4.337-5.044zM84.443 33.61l-10.251-13.01 10.155-10.18h-7.27l-8.339 8.483V.76h-6.29v32.851h6.29V22.723l8.247 10.888h7.458zm-24.732-6c-.427.249-2.686 1.43-5.44 1.43-4.197 0-6.248-3.114-6.248-7.166 0-3.299 2.237-6.975 6.431-6.975 2.61 0 4.52 1.134 4.846 1.368l.363-5.212c-1.34-.67-3.272-1.295-5.77-1.295-6.894 0-12.159 5.232-12.159 12.444 0 6.883 4.567 12.068 11.742 12.068 2.773 0 4.96-.73 6.456-1.457l-.221-5.205z"
          id="da"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="db" fill="#fff">
          <use xlinkHref="#da"></use>
        </mask>
        <use fill="#131413" xlinkHref="#da"></use>
        <g mask="url(#db)" fill="#FFF">
          <path d="M0 0h85v35H0z"></path>
        </g>
      </g>
    </symbol>
    <use href="#teck-logo"></use>
  </svg>
);

export default TeckLogo;
